let dt_index = null;
let microsite_id = null;
let redirection_id = null;
let url_source = '';

export function index(params){

    dt_index = $('#redirections_table').DataTable({
        ajax: {
            url: $('#redirections_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_redirections_actions },
            { data: 'type', orderable: true, searchable: true },
            { data: 'source', orderable: true, searchable: true },
            { data: 'destination', orderable: true, searchable: true },
        ],
        order: [[3, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_redirections"]').click(batch_delete_redirections);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_redirections_actions(data, type, row){

    const url_info = ($("#redirections_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

//show

export function show(params){

    microsite_id = params.microsite_id;
    redirection_id = params.redirection_id;
    url_source = params.url_source;
}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();
}

export function change_url_source(params){

    url_source = params.url_source;
    let form = $('#edit_redirection');
    let input_source = form.find('input[name="source"]');
    input_source.val(url_source);

}

function batch_delete_redirections(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.redirections.batch_delete'].replace('{microsite}', microsite_id);
    
    let redirections_id = [];
    $.each(rows_selected, function(index, rowId){
        redirections_id.push(rowId);
    });
    
    if(redirections_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna redirección'));

    } else {

        const title = __('Eliminar redirecciones');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una redirección.|[2,*] Estás a punto de eliminar :count redirecciones.', redirections_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let redirection_id of redirections_id){
                        formData.append('redirections_id[]', redirection_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}